import { useEffect, useState } from "react";
import API from "../api";

function InventorySidebar() {

  const [inventory, setInventory] = useState([]);

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = () => {
    API.get("inventory/get-inventory/")
      .then(res => setInventory(res.data));
  };

  return (
    <div>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0">Inventory</h6>
      </div>

      <table className="table table-sm table-bordered">
        <thead className="table-light">
          <tr>
            <th>Sheet</th>
            <th width="70">Stock</th>
          </tr>
        </thead>

        <tbody>
          {inventory.map(item => (
            <tr key={item.id}>
              <td>
                <small>
                  {item.name}
                </small>
              </td>

              <td>
                <span className={`badge ${
                  item.stock_sheets < 5
                    ? "bg-danger"
                    : item.stock_sheets < 10
                    ? "bg-warning text-dark"
                    : "bg-success"
                }`}>
                  {item.stock_sheets}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}

export default InventorySidebar;
